module.exports = __webpack_public_path__ + "static/media/energie5.84631655.jpg";